var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconArrowUp = function SvgIconArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23191 8.64C3.58591 9.064 4.21591 9.122 4.63991 8.768L8.99991 5.135V17C8.99991 17.552 9.44791 18 9.99991 18C10.5519 18 10.9999 17.552 10.9999 17V5.135L15.3599 8.768C15.7849 9.122 16.4149 9.064 16.7679 8.64C17.1219 8.216 17.0649 7.585 16.6399 7.232L10.6399 2.232C10.5929 2.192 10.5369 2.173 10.4849 2.143C10.4439 2.119 10.4079 2.091 10.3629 2.073C10.2459 2.027 10.1239 2 9.99991 2C9.87591 2 9.75391 2.027 9.63691 2.073C9.59191 2.091 9.55591 2.119 9.51491 2.143C9.46291 2.173 9.40691 2.192 9.35991 2.232L3.35991 7.232C2.93591 7.585 2.87791 8.216 3.23191 8.64Z",
    fill: "#1D2E69"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-arrow-up.5a3949b8.svg";
export { ForwardRef as ReactComponent };